/**
 * @description: use required props to compute mocked value for display purpose. And with functionality to avoid useless computation if no setting changes.
 * required props:
 * @param: {Array} fieldsMetaData
 * @param: {Object} report
 * @param: {Object} slotData
 * return a @param {Array} data w/ specific formats
 */
import React, { Component } from 'react';
import Enums from 'utils/EnumsManager';
import { CustomizedFields } from 'models';

const { FieldTypes, REPORTS, SortOrders } = Enums;
const { NumberInput } = FieldTypes;
const { ROWSPERGROUP } = REPORTS.PREVIEW;
const { ascend } = SortOrders;

const getMockData = WrappedComponent =>
  class extends Component {
    shouldComponentUpdate(nextProps) {
      // TODO: avoid unnecessary recomputation on mock values
      return true;
    }

    getRowData = (fields, index) => {
      const data = { id: index };
      fields.forEach((f, i) => {
        data[i < 1 ? 'group' : 'aggregate'] = f ? f.getMockedValue() : null;
      });
      return data;
    };
    getMockedTableData = () => {
      const fields = this.getColumnFields().filter(f => !_.isEmpty(f));
      if (fields.length < 1) return [];

      const rawData = this.getRawTableData(fields);
      return this.sortTableData(rawData);
    };
    getRawTableData = fields => {
      const data = [];
      for (let i = 0; i < ROWSPERGROUP; i++) {
        data.push(this.getRowData(fields, i));
      }
      return data;
    };
    // Get meta data for selected column fields, i.e. group and aggregate
    getColumnFields = () => {
      const { report, fieldsMetaData, slotData } = this.props;
      if (
        _.isEmpty(report) ||
        _.isEmpty(fieldsMetaData) ||
        _.isEmpty(slotData)
      ) {
        return [];
      }

      const { type } = report;
      const fieldsInType = fieldsMetaData.filter(f => f.objectType === type);
      // add field option, which is named 'Count' to all dashboard setting.
      const countField = new CustomizedFields[NumberInput]({
        id: 'count',
        name: 'count',
        label: 'Count',
        isSystemField: false,
        modelType: `App\\Mode\\${_.capitalize(type)}`,
        type: NumberInput,
        restriction: false
      });
      fieldsInType.push(countField);
      const groupField = fieldsInType.find(f => this.isGroupCol(f.name), this);
      const aggregateField = fieldsInType.find(
        f => this.isAggregateCol(f.name),
        this
      );
      return [groupField, aggregateField];
    };
    isGroupCol = fieldName => {
      const { groupSettings } = this.props.slotData;
      if (_.isEmpty(groupSettings)) return false;

      return groupSettings === fieldName;
    };
    isAggregateCol = fieldName => {
      const { slotData } = this.props;
      const { summarySettings } = slotData;
      if (_.isEmpty(summarySettings)) return false;

      // format name
      let replacer = '';
      if (_.endsWith(summarySettings, '__sum')) {
        replacer = '__sum';
      } else if (_.endsWith(summarySettings, '__avg')) {
        replacer = '__avg';
      }
      return summarySettings.replace(replacer, '') === fieldName;
    };
    sortTableData = data => {
      const { slotData } = this.props;
      const { groupSettings, summarySettings, orderSettings } = slotData;

      if (_.isEmpty(groupSettings) && _.isEmpty(summarySettings)) return data;

      const isSortOnGroup = groupSettings === orderSettings.field_name;
      const sortedData = _.sortBy(data, isSortOnGroup ? 'group' : 'aggregate');
      return orderSettings.direction === ascend
        ? sortedData
        : sortedData.reverse();
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          tableData={this.getMockedTableData()}
        />
      );
    }
  };

export default getMockData;



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/Table/components/getMockData.jsx